// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__Z9aA_","h2":"styles_h2___6C8d","h3":"styles_h3__QuZ6p","h4":"styles_h4__VdH9w","h5":"styles_h5__r4AuK","h6":"styles_h6__NNjTP","bold":"styles_bold__1Ag8f"};